import type { Service } from '@/services/firestore/types';

export function formatCatalogPrice(cents: number | undefined) {
  if (cents == null) {
    return '';
  }

  const dollars = cents / 100;
  return dollars % 1 === 0 ? `$${dollars.toFixed(0)}` : `$${dollars.toFixed(2)}`;
}

export function catalogPrice(service: Service) {
  return formatCatalogPrice(service.priceCents);
}
